import React from "react";
import { Wrapper } from "./trackingTitle.styles";

export const TrackingTitle = () => {
  return (
    <Wrapper>
      <div className="tracking-title">
        <p>Thank you for your loan application with us.</p>
        <h2>Track your application progress below</h2>
      </div>
    </Wrapper>
  );
};
